import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Container, Typography } from '@mui/material';
import Course from '../Course/Course';
import { Button } from '@material-ui/core';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { NavLink } from 'react-router-dom';


const Courses = () => {
    // useState for products 
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const spinnerStyle = {
        width: "3rem",
        height: "3rem",
    };
    // useEffect for courses 
    useEffect(() => {
        fetch('https://warm-oasis-84574.herokuapp.com/explore')
            .then(res => res.json())
            .then(data => {
                setCourses(data);
                setIsLoading(false);
            });
    }, [])
    return (

        <Box sx={{ flexGrow: 1, mt: 5 }} style={{ paddingTop: "30px", paddingBottom: '100px' }}>
            <Container>
                <Typography variant="h1" className="heading" style={{ fontFamily: 'Raleway', pb: 0, fontSize: "2.5rem" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                    gutterBottom>

                    <span>L</span>
                    <span>A</span>
                    <span>T</span>
                    <span>E</span>
                    <span>S</span>
                    <span>T</span>
                    <span className="space">{""}</span>
                    <span>C</span>
                    <span>O</span>
                    <span>U</span>
                    <span>R </span>
                    <span>S </span>
                    <span>E </span>
                    <span>S </span>

                </Typography>

                {/* <Typography sx={{ fontFamily: 'Raleway', fontWeight: "700", pb: 0, textAlign: "center" }} variant="h3" gutterBottom component="div">
                    <span style={{ borderBottom: '3px solid #8341ED', fontStyle: 'italic' }}>Latest</span>  Courses
                </Typography> */}
                <Typography sx={{ fontFamily: 'Raleway', color: "black", textAlign: "center" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                    variant="h6" gutterBottom component="div">
                    Find you most suitable Courses for your career.
                </Typography>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingTop: "30px" }}>
                    {isLoading ? (
                        <div className="text-center my-5 py-5">
                            <div
                                className="spinner-grow color-1 mt-5"
                                style={spinnerStyle}
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )
                        :


                        courses.slice(0, 3).map(course =>
                            <Course
                                key={course.key}
                                course={course}
                            ></Course>

                        )}
                </Grid>
                <NavLink to="/explore" data-aos="zoom-out-up"
                    data-aos-duration="1000" data-aos-easing="ease-in-sine">
                    <button className="primary-button transition">
                        Explore More <DoubleArrowIcon sx={{ ml: 2 }} />
                    </button>
                </NavLink>

            </Container>

        </Box>




    );
};

export default Courses;